import { useEffect } from "react";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { formatDate } from "@/shared/lib/utilities/date";
import {
  ConnectInvoiceExportDialog,
  useSetConnectInvoiceExportText,
} from "@/services/backend/connect/components/connect-invoice-export";
import {
  useAttachmentsString,
  useServiceKindTitle,
  useWorkOrderReference,
} from "@/services/backend/connect/components/string-builder-helpers";
import { useHtzWorkOrderListPositionQuery } from "@/services/backend/htz/work-order/api/work-order-api";
import { WorkOrder } from "@/services/backend/htz/work-order/types/work-order";
import { useHtzPositionPrices } from "./string-builder-helpers-htz";

export function ConnectInvoiceExportDialogHtz({
  workOrder,
}: {
  workOrder: WorkOrder;
}) {
  return (
    <ConnectInvoiceExportDialog>
      <HtzInvoiceExport workOrder={workOrder} />
    </ConnectInvoiceExportDialog>
  );
}

export function HtzInvoiceExport({ workOrder }: { workOrder: WorkOrder }) {
  const setText = useSetConnectInvoiceExportText();
  const { data: positions } = useHtzWorkOrderListPositionQuery({
    workOrder: { active: true, values: [workOrder.id] },
  });

  const title = useServiceKindTitle(GSMServiceKind.HTZ);
  const workOrderReference = useWorkOrderReference(
    workOrder,
    GSMServiceKind.HTZ,
  );
  const positionPrices = useHtzPositionPrices(
    positions ? positions.items : undefined,
  );
  const attachments = useAttachmentsString();

  const beginDate = workOrder.beginDate ?? "";

  useEffect(() => {
    setText(
      [
        title,
        "",
        workOrderReference,
        `Leistungszeitpunkt: ${formatDate(beginDate)}`,
        "",
        positionPrices,
        "",
        attachments,
      ].join("\n"),
    );
  }, [
    setText,
    title,
    workOrderReference,
    beginDate,
    positionPrices,
    attachments,
  ]);

  return null;
}
